export const GLOBAL_COLORS: readonly string[] = [
  '#71B8F1',
  '#94D4DE',
  '#C1A0FF',
  '#E8B5A8',
  '#D1A7BE',
  '#B2D8F9',
  '#ECD88F',
  '#B0D9B0',
  '#A1B6C4',
  '#FFB7B2',
];

export const GLOBAL_COUNT_COLOR = '#000000';
